module.exports = __webpack_public_path__ + "static/media/nato.55474920.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nato.svg
// module id = 2171
// module chunks = 0